module.exports = __webpack_public_path__ + "static/img/join-us-banner.3a22ab2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join-us/join-us-banner.jpg
// module id = Pds0
// module chunks = 15